import { Title } from "@mantine/core"
import { Loader, Card, InfoBox } from "@tfg/ui"
import { useMemo, useState } from "react"
import { useTranslation } from "react-i18next"

import {
  dateFilterDtoOperatorEnum,
  dateFilterDtoPresetEnum,
  dateFilterDtoTypeEnum,
  useFindAgecComplianceStats,
} from "~/gen/api"
import { AgecComplianceContent } from "~/pages/Brand/Home/components/AgecComplianceContent"
import { useIngestionDateFilter } from "~/pages/Brand/Home/hooks/useIngestionDateFilter"

export const AgecCompliance = () => {
  const { t } = useTranslation(["home", "common"])

  const [brandTypeFilter, setBrandTypeFilter] = useState<string[]>([])
  const [collectionFilter, setCollectionFilter] = useState<string[]>([])

  const {
    options: ingestionDateOptions,
    ingestionDateFilter,
    setIngestionDateFilter,
    getIngestionDateRange,
  } = useIngestionDateFilter()

  const ingestionDateRange = useMemo(() => {
    return getIngestionDateRange()
  }, [getIngestionDateRange])

  const { data: statsResponse, isLoading } = useFindAgecComplianceStats({
    filters: {
      type: brandTypeFilter,
      collection: collectionFilter,
      ...(ingestionDateRange
        ? {
            ingestionDate: {
              operator: dateFilterDtoOperatorEnum.between,
              type: dateFilterDtoTypeEnum.fixed,
              preset: dateFilterDtoPresetEnum.custom,
              range: {
                startDate: ingestionDateRange.start?.toDate(),
                endDate: ingestionDateRange.end.toDate(),
              },
            },
          }
        : {}),
    },
  })

  const { stats, filtersOptions: allFilterOptions } = statsResponse?.data ?? {}

  const { brandTypeOptions, collectionOptions } = useMemo(() => {
    return {
      brandTypeOptions:
        allFilterOptions?.brandType.map((brandType) => ({
          label: brandType,
          value: brandType,
        })) ?? [],
      collectionOptions:
        allFilterOptions?.collection.map((collection) => ({
          label: collection,
          value: collection,
        })) ?? [],
    }
  }, [allFilterOptions])

  return (
    <Card>
      <Card.Header>
        <Title order={3}>{t("agecCompliance.title")}</Title>
      </Card.Header>
      <Card.Section>
        {isLoading || !stats ? (
          <Loader fullPage mb="sm" />
        ) : stats.total > 0 ? (
          <AgecComplianceContent
            collectionOptions={collectionOptions}
            brandTypeOptions={brandTypeOptions}
            ingestionDateOptions={ingestionDateOptions}
            ingestionDateFilter={ingestionDateFilter}
            setIngestionDateFilter={setIngestionDateFilter}
            collectionFilter={collectionFilter}
            setCollectionFilter={setCollectionFilter}
            brandTypeFilter={brandTypeFilter}
            setBrandTypeFilter={setBrandTypeFilter}
            stats={stats}
          />
        ) : (
          <InfoBox
            title={t("common:dataLoad.noResults.title")}
            message={t("common:dataLoad.noResults.message")}
          />
        )}
      </Card.Section>
    </Card>
  )
}
